require('es6-promise');
require('isomorphic-fetch');

import config from '../../src/config';
import { getUrlParams } from './common-helper';
import { registerWxClientEvent } from './wx-client-helper';
import { WxSharEventEntry } from './const';
import defaultImage from '../asset/images/share.png';
import defaultMember from '../asset/images/defaultMember.png';
import defaultDish from '../asset/images/defaultDish.png';
import httpReq from '../helper/http-request-helper';
const params = getUrlParams() || {};
const { shopId } = params;
const search = location.search;

  // 配置 title link  imgUrl
function getConfigItem(entry) {
  switch (entry) {
    case WxSharEventEntry.SHOP:
      return Promise.resolve({
        title: '门店首页',
        desc: '这家店的东西都很不错~一定有你喜欢的',
        link: `${config.shopDetailURL}?shopId=${shopId}`,
        imgUrl: defaultImage,
      });

    case WxSharEventEntry.DETAIL: {
      return Promise.resolve({
        title:  document.title, // '商品详情页',
        desc: '好东西，一定要分享啦',
        link: `${config.goodsDetailURL}${search}`,
        imgUrl: defaultDish,
      });
    }

    case WxSharEventEntry.MEMBER:
      return httpReq.get(config.indexAPI, { shopId })
        .then((res = {}) => {
          if (res.code !== '200') {
            return {};
          }

          return {
            title: '会员注册页',
            desc: `成为[${res.data.brand.name}]会员，享受会员专属权益`,
            link: `${config.registerMemberURL}?shopId=${shopId}`,
            imgUrl: defaultMember,
          };
        });

    case WxSharEventEntry.BRAND: {
      return Promise.resolve({
        title: '品牌首页',
        desc: '这家店的东西都很不错~一定有你喜欢的',
        link: `${config.brandIndexURL}?shopId=${shopId}`,
        imgUrl: defaultImage,
      });
    }

    default:
      return Promise.resolve({});
  }
}

const initWXShareEventWithConfig = (args, callBack) => {
  const { entry, _this } = args;

  if (_this.initSharEvent) {
    return;
  }

  _this.initSharEvent = true;

  const shareConfigObj = getConfigItem(entry);
  // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
  const shareTimeline = (wx) => {
    if (wx.onMenuShareTimeline) {
      shareConfigObj.then(res => {
        wx.onMenuShareTimeline({
          ...res,
          success: () => {
            if (callBack) {
              callBack();
            }
          }, // 成功回调事件
        });
      });
    }
  };

  // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
  const shareAppMessage = (wx) => {
    if (wx.onMenuShareAppMessage) {
      shareConfigObj.then(res => {
        wx.onMenuShareAppMessage({
          ...res,
          success: () => {
            if (callBack) {
              callBack();
            }
          }, // 成功回调事件
        });
      });
    }
  };

  // onMenuShareAppMessage onMenuShareTimeline
  registerWxClientEvent(['onMenuShareAppMessage', 'onMenuShareTimeline'], {
    success: (wx) => {
      shareTimeline(wx);
      shareAppMessage(wx);
    },
    error: (err) => {
      console.log('公众号配置错误');
    },
  });
};

exports.initWXShareEventWithConfig = initWXShareEventWithConfig;



// WEBPACK FOOTER //
// ./src/helper/wx-share-config.js